const IOS_TAGS = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod'
]

export const state = {
  width: 0,
  height: 0,
  orientation: 'n/a',
  isIos:  IOS_TAGS.includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document),
  retinaRatio: window.devicePixelRatio
}

export const mutations = {
  SET_WINDOW_WIDTH(state, newValue) {
    state.width = newValue
  },
  SET_WINDOW_HEIGHT(state, newValue) {
    state.height = newValue
  },
  SET_ORIENTATION(state, newValue) {
    state.orientation = newValue
  },
}

export const getters = {
  isMobile(state){
    return state.width < 768
  },
  isTablet(state){
    return state.width < 1024
  },
  isLargeTablet(state){
    return state.width < 1280
  },
  width(state){
    return state.width
  },
  height(state){
    return state.height
  },
  orientation(state){
    return state.orientation
  },
  isPortrait(state){
    if (state.orientation){
      return state.orientation.toLowerCase().startsWith('portrait')
    }
    return false
  },
  isLandscape(state){
    if (state.orientation){
      return state.orientation.toLowerCase().startsWith('landscape')
    }
    return false
  },
  isIos(state){
    return state.isIos
  },
  isRetina(state){
    return state.retinaRatio > 1
  },
  retinaRatio(state){
    return state.retinaRatio
  },
}

export const actions = {
  setWidth({ commit, state }, value) {
    commit('SET_WINDOW_WIDTH', value)
  },
  setHeight({ commit, state }, value) {
    commit('SET_WINDOW_HEIGHT', value)
  },
  setOrientation({ commit, state }, value) {
    commit('SET_ORIENTATION', value)
  },
}
